import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { Student } from '@chancenwerk/master-data-management/users/entities/Student.js';

export namespace UserPublicInformationAPI {
  export const anmeldungAlreadyRegistered = registerQuery({
    type: () => Boolean,
    operationName: 'anmeldungAlreadyRegistered',
    params: [{ type: () => [String], name: 'emails' }],
    resolve: (emails: string[]) => {
      return async () => {
        emails = emails.filter(Boolean);
        if (emails.length > 3) {
          return false;
        }

        const col = await getRawCollection<Student>(Student._collectionName);
        const res = await col.findOne(
          {
            _class: Student._class,
            $or: [
              { email: { $in: emails } },
              { 'legalGuardian1.email': { $in: emails } },
              { 'legalGuardian2.email': { $in: emails } },
            ],
          },
          { projection: { _id: 1 } },
        );

        return !!res;
      };
    },
  });
}
